export function getRobotsContent(directives) {
    return `max-image-preview:large${directives ? `, ${directives}` : ''}`;
}
